var render, staticRenderFns
import script from "./c-schedule-detail.vue?vue&type=script&lang=js"
export * from "./c-schedule-detail.vue?vue&type=script&lang=js"
import style0 from "./c-schedule-detail.vue?vue&type=style&index=0&id=38932bc9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38932bc9",
  null
  
)

export default component.exports